'use es6';

export var SECOND = 1000;
export var REDIRECT_DELAY_IN_SECONDS = 3;